import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { Mixins, Spacing } from 'web-common/src/shared/styles';
import { BaseTextArea, BaseTextAreaProps } from '../BaseTextArea';

interface TextAreaProps extends BaseTextAreaProps {
  /** Light theme (White background) */
  light?: boolean;
  autoFocus?: boolean;
}

export const TextArea = styled(BaseTextArea)<TextAreaProps>`
  ${ifProp('light', Mixins.Input.TextAreaLightStyles, Mixins.Input.TextAreaStyles)}
  min-height: ${Spacing.TRIPLE_HALF};
`;
